import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { enLaListaDeWhatsapp } from "../../services/whatsappDelBot";

/* El cartel de «no está en la lista de WhatsApp» (Nico, 06/10).
 *
 * Se muestra cuando se le va a dar algo a alguien a quien el bot no le puede
 * escribir: si es un préstamo, los recordatorios para devolverla no le van a
 * llegar. Dice dónde se lo agrega —el bot sabe si es chofer (Choferes
 * autorizados) o del taller (la lista del bot)— para cerrar el flujo ahí.
 *
 * Sin respuesta del bot no dice nada: ver `enLaListaDeWhatsapp`.
 */
export default function AvisoWhatsapp({ dni, nombre, prestar = false }) {
  const [r, setR] = useState(null);

  useEffect(() => {
    let vivo = true;
    setR(null);
    if (!dni) return undefined;
    Promise.resolve(enLaListaDeWhatsapp(dni))
      .then((x) => { if (vivo) setR(x || null); })
      .catch(() => { if (vivo) setR(null); });
    return () => { vivo = false; };
  }, [dni]);

  if (!r || r.enLista !== false) return null;
  const a = r.agregar;
  return (
    <p className="hrr-aviso hrr-aviso-wa" role="status">
      📵 <b>{nombre || "Esta persona"}</b> no está en la lista de WhatsApp del bot
      {prestar ? ": no le van a llegar los recordatorios para devolverla." : "."}
      {" "}Sumala para tener todo el flujo.
      {a && (
        <>
          {" "}
          {a.interno
            ? <Link to={a.url}>{a.rotulo} →</Link>
            : <a href={a.url} target="_blank" rel="noreferrer">{a.rotulo} ↗</a>}
        </>
      )}
    </p>
  );
}
